<form [formGroup]="FormGroup">
  <section class="start-date">
    <mat-form-field>
      <input
        (click)="startDate.open()"
        (dateChange)="onDateChange('startDate')"
        (inputChange)="onDateChange('startDate')"
        [matDatepicker]="startDate"
        formControlName="startDate"
        matInput
        placeholder="Event Date"
        required
        />
      <mat-datepicker-toggle
        [for]="startDate"
        matSuffix
      ></mat-datepicker-toggle>
      <mat-datepicker
        #startDate
        [startAt]="FormGroup.controls['startDate'].value"
      ></mat-datepicker>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Time (optional)</mat-label>
      <mat-select
        (selectionChange)="onStartTimeChange($event)"
        formControlName="startTime"
        >
        <mat-option [value]="null">-- None --</mat-option>
        @for (time of eventTimes; track time) {
          <mat-option [value]="time">
            {{time.name}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </section>
  <section>
    <mat-slide-toggle
      (change)="setEventCalendar($event.checked)"
      [checked]="calendar"
      >Show on app event calendar
    </mat-slide-toggle>
  </section>
  <section>
    <mat-slide-toggle
      (change)="setStagedRelease($event.checked)"
      [checked]="stagedRelease"
      >Staged ticket release
    </mat-slide-toggle>
    @if (stagedRelease) {
      <div>
        <p class="releaseMessage">
          Ticket release will be split between 7am and 10pm on the selected date
        </p>
        <mat-form-field>
          <input
            (click)="dateOfRelease.open()"
            (dateChange)="onDateChange('stagedReleaseDate')"
            (inputChange)="onDateChange('stagedReleaseDate')"
            [matDatepicker]="dateOfRelease"
            formControlName="stagedReleaseDate"
            matInput
            placeholder="Release Date"
            />
          <mat-datepicker-toggle
            [for]="dateOfRelease"
            matSuffix
          ></mat-datepicker-toggle>
          <mat-datepicker
            #dateOfRelease
            [startAt]="FormGroup.controls['stagedReleaseDate'].value"
          ></mat-datepicker>
        </mat-form-field>
      </div>
    }
  </section>
  <section class="dangerous-settings">
    <header>
      <h3>
        <mat-icon>warning</mat-icon>
        Dangerous Settings
        <mat-slide-toggle formControlName="showDangerousSettings"
          >Show dangerous settings</mat-slide-toggle
          >
        </h3>
        <p class="message">
          These settings can cause unexpected outcomes, if you are not sure what
          you are doing.
        </p>
      </header>
      @if (FormGroup.controls['showDangerousSettings'].value || (FormGroup.dirty && FormGroup.invalid)) {
        <section
          class="settings"
          >
          <mat-slide-toggle (change)="setAnarchy(!$event.checked)" [checked]="rules"
            >Purchasing Rules
          </mat-slide-toggle>
          <section class="end-date">
            <mat-slide-toggle
              (change)="setEndDateFixed($event.checked)"
              [checked]="endDateFixed"
              >Multi-Day Event
            </mat-slide-toggle>
            @if (endDateFixed) {
              <mat-form-field>
                <input
                  (click)="endDate.open()"
                  (dateChange)="onDateChange('endDate')"
                  (inputChange)="onDateChange('endDate')"
                  [matDatepicker]="endDate"
                  [min]="FormGroup.controls['startDate'].value || null"
                  formControlName="endDate"
                  matInput
                  placeholder="Event End Date"
                  />
                <mat-datepicker-toggle
                  [for]="endDate"
                  matSuffix
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #endDate
                  [startAt]="FormGroup.controls['endDate'].value || FormGroup.controls['startDate'].value"
                ></mat-datepicker>
                @if (FormGroup.controls['endDate']?.errors) {
                  <mat-error
                    >{{ FormGroup.controls['endDate']?.errors[0].message }}</mat-error
                    >
                  }
                </mat-form-field>
              }
            </section>
          </section>
        }
      </section>
    </form>
